export default "__VITE_ASSET__684bfd23__"